import React from "react";
import "../styles/whyus.css"; // Why Us section specific styles
import "../styles/master.css";
import whyusData from "../data/whyusData.json"; // Import the JSON data

const WhyUs = () => {
  return (
    <section id="whyus" className="whyus">
      <h2 className="title">{whyusData.title}</h2>
      <p className="main-content">{whyusData.mainContent}</p>

      <div className="about-sections">
        {whyusData.sections.map((section, index) => (
          <div key={index} className="about-section">
            <h3>{section.title}</h3>
            <p>{section.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUs;
